module.exports = __webpack_public_path__ + "static/media/dv360-logo.e5939f72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dv360-logo.svg
// module id = 1698
// module chunks = 0